import * as Joi from "joi";
import i18n from "src/i18n";
import { join, set } from "lodash";
import { parsePhoneNumber } from "libphonenumber-js";

const extractJoiErrorDetails = (error) => {
  const { details } = error;
  const errorDetails = {};
  details.forEach((detail) => {
    const nestedPath = join(detail.path, ".");
    set(errorDetails, nestedPath, detail.message.replace(/"/g, ""));
  });
  return errorDetails;
};

export const runJoiValidate = (schema, values) => {
  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return;
  if (typeof values === 'object') return extractJoiErrorDetails(error)
  if (typeof values === 'string') return error.details[0].message
};

export const joiObject = Joi.extend((joi) => {
  return {
    type: 'object',
    base: joi.object(),
    messages: {
      'any.required': `{#label} ${i18n?.t("validationErrors.isRequired")}`,
      'string.empty': `{#label} ${i18n?.t("validationErrors.isEmpty")}`,
    }
  }
});

export const joiString = Joi.extend((joi) => {
  return {
    type: 'string',
    base: joi.string(),
    messages: {
      'any.required': `{#label} ${i18n?.t("validationErrors.isRequired")}`,
      'string.uri': `{#label} ${i18n?.t("validationErrors.isURI")}`,
      'string.empty': `{#label} ${i18n?.t("validationErrors.isEmpty")}`,
      'string.min': `{#label} ${i18n?.t("validationErrors.minChar")} {#limit}`,
      'string.max': `{#label} ${i18n?.t("validationErrors.maxChar")} {#limit}`,
      'string.email': `{#label} ${i18n?.t("validationErrors.isEmail")}`,
      'any.only': `{#label} ${i18n?.t("validationErrors.isPasswordMatch")}`,
      'string.base': `{#label} ${i18n?.t("validationErrors.isString")}`,
      'string.pattern.base': `{#label} ${i18n?.t("validationErrors.isInvalidFormat")}`,
    }
  }
});

export const joiNumber = Joi.extend((joi) => {
  return {
    type: 'number',
    base: joi.number(),
    messages: {
      'any.required': `{#label} ${i18n?.t("validationErrors.isRequired")}`,
      'number.empty': `{#label} ${i18n?.t("validationErrors.isEmpty")}`,
      'number.min': `{#label} ${i18n?.t("validationErrors.minNumber")} {#limit}`,
      'number.max': `{#label} ${i18n?.t("validationErrors.maxNumber")} {#limit}`,
      'number.base': `{#label} ${i18n?.t("validationErrors.isNumber")}`,
      'number.positive': `{#label} ${i18n?.t("validationErrors.isMoreThanZero")}`,
    }
  }
});

export const joiArray = Joi.extend((joi) => {
  return {
    type: 'array',
    base: joi.array(),
    messages: {
      'any.required': `{#label} ${i18n?.t("validationErrors.isRequired")}`,
      'array.empty': `{#label} ${i18n?.t("validationErrors.isEmpty")}`,
      'array.min': `{#label} ${i18n?.t("validationErrors.minArray")} {#limit}`,
      'array.max': `{#label} ${i18n?.t("validationErrors.maxArray")} {#limit}`,
      'array.base': `{#label} ${i18n?.t("validationErrors.isArray")}`,
    }
  }
});

export const PHONE_VALIDATION = joiString.string()
  .required()
  .label(i18n?.t("form.phone", { ns: "public" }) || "Phone")
  .empty('')
  .custom((value, helpers) => {
    const parsedPhone = parsePhoneNumber(value, { extract: true });
    if (!parsedPhone || !parsedPhone.isValid())
      return helpers.message(i18n?.t("validationErrors.isValidPhone"));
    return value
  })

export const IMAGE_SCHEMA = (label) => (joiObject.object({
  baseURL: joiString.string().empty(''),
  name: joiString.string().label(label).required(),
  provider: joiString.string().empty('').optional(),
  sizes: joiArray.array().optional()
}))

